import LocationProps from "../props/LocationProps"

export interface ISort {
  [key: string]: (locations:LocationProps[]) => LocationProps[]
}

const LocationSort:ISort = {
  alpha: (locations) => {
    locations.sort((a, b) => {
      const textA:string = a.title.toUpperCase()
      const textB:string = b.title.toUpperCase()
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
    })
    return locations as LocationProps[]
  },
  ralpha: (locations:LocationProps[]) => LocationSort.alpha(locations).reverse(),
  distance: (locations:LocationProps[]) => {
    locations.sort((a, b) => {
      if (!a.distance|| !b.distance) return 0
      const distA = a?.distance
      const distB = b?.distance
      return (distA < distB) ? -1 : (distA > distB) ? 1 : 0
    })
    return locations
  }
}

export default LocationSort
